import { schema } from 'normalizr';

const briefQuestionSchema = new schema.Entity('publicQuestions');

export default briefQuestionSchema;
